import { create } from 'zustand'

import type { ADUserI } from '@/types'

export type User = ADUserI & { initials: string; avatarUrl?: string }
export type Role = 'SUPER_ADMIN' | 'ADMIN' | 'USER'
export type UserPermissions = { role: Role } & Record<string, unknown>

type AuthStore = {
  user: User | null
  userLoading: boolean
  permissions: UserPermissions | null
  permissionsError: boolean
  setUser: (user: User | null) => void
  setUserLoading: (loading: boolean) => void
  setPermissions: (permissions: UserPermissions | null) => void
  setPermissionsError: (error: boolean) => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  userLoading: true,
  permissions: null,
  permissionsError: false,

  setUser: (user) => set({ user }),
  setUserLoading: (userLoading) => set({ userLoading }),
  setPermissions: (permissions) => set({ permissions }),
  setPermissionsError: (permissionsError) => set({ permissionsError }),
}))
